export default __webpack_public_path__ + "fonts/poppins-latin-200-normal.9a201ad3b2d2138a7e77.woff";